import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
  VStack,
  Box,
  Heading,
  Text,
  Icon,
  Divider,
  List,
  ListItem,
  ListIcon,
  Container,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { FaCircle } from "react-icons/fa";

function Index() {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions</title>
        <meta name="description" content="NCVS - Terms & Conditions" />
        <meta name="keywords" content="" />
      </Helmet>

      <Box minH="100vh" color="white" py={10}>
        <Container maxW="container.lg" py={8}>
          <Box mb="5">
            <Link to="/auth/login">
              <Text fontSize={{ sm: "md", md: "lg" }} color="#000000">
                <Icon as={ArrowBackIcon} /> Back
              </Text>
            </Link>
          </Box>
          <VStack
            spacing={6}
            align="stretch"
            color="#000000"
            fontFamily={"Urbanist"}
            fontSize={{ sm: "md", md: "lg" }}
          >
            <Heading
              as="h1"
              size="xl"
              textAlign="center"
              color="#000000"
              fontFamily={"Urbanist"}
            >
              Terms and Conditions
            </Heading>

            <Text fontWeight="bold">
              PLEASE READ THESE TERMS CAREFULLY BEFORE REGISTERING AN ACCOUNT
              WITH NATIONAL EDUCATION REPOSITORY AND DATABANK (NERD) NED.GOV.NG.
            </Text>

            <Text>
              These terms tell you (the "Customer") who we are, how we will
              provide services to you, how you and we may change or end the
              contract, what to do if there is a problem and other important
              information. By accessing and using the services we provide, you
              agree to be bound by the terms and conditions contained herein,
              which establishes a contractual relationship between you and NERD.
            </Text>

            {/* Section 1.0 */}
            <Box>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                1.0 DEFINITIONS
              </Heading>

              <List spacing={3}>
                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "Authorized User"
                  </Text>{" "}
                  means those employees, agents, customers and independent
                  contractors of Customer that have been assigned a user ID or
                  password and authorized by Customer to access and use the
                  Services.
                </ListItem>

                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "Certificate Cloud Services” or “Services"
                  </Text>{" "}
                  means the products and services offered by NERD under the name
                  “NERD Certificates”, “NERD Portfolios”, “NERD Professional
                  Profiles” or successor branding. Certificate Cloud Services
                  exclude: (a) third party Credentials including without
                  limitation any certification, testing, identity verification;
                  and (b) non-NERD applications.
                </ListItem>

                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "National Credential Verification Service" or "Services"
                  </Text>{" "}
                  means the products and services offered by NERD under the name
                  "NCVS" or successor branding. NCVS Services exclude: (a) third
                  party Credentials including without limitation any
                  certification, testing, identity verification; and (b)
                  non-NERD applications.
                </ListItem>

                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "Confidential Information"
                  </Text>{" "}
                  shall have the meaning set forth in Section 11.1.
                </ListItem>

                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "Content"
                  </Text>{" "}
                  means the NERD content, information, data products and
                  services made available as part of the Certificate Cloud
                  Services.
                </ListItem>

                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "Credentials"
                  </Text>{" "}
                  means evidence of achievement, ability, attainment,
                  authenticity, compliance, completion, eligibility,
                  entitlement, experience, identity, membership, qualifications,
                  title or other attributes, qualities or traits.
                </ListItem>

                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "Customer Data"
                  </Text>{" "}
                  means Customer’s content, information and data which Customer
                  desires to process and disseminate by accessing and using the
                  Service and any Customer icons, marks and/or logos Customer
                  desires to have displayed on the Service pages. As between
                  Customer and NERD, Customer Data shall also include
                  Credentials whether of (or issued by), Customer or third
                  parties.
                </ListItem>

                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "Documentation"
                  </Text>{" "}
                  means the online guides and user manuals for the Service.
                </ListItem>

                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "Intellectual Property Rights"
                  </Text>{" "}
                  means all patents, patent registration or applications,
                  business processes, data rights, copyrights, trade names,
                  trademarks, trade secrets, know-how, mask works, or any other
                  intellectual property rights, whether registered or
                  unregistered, arising or enforceable under the law of the
                  Federal Republic of Nigeria or the law of any other
                  jurisdiction.
                </ListItem>

                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "Term"
                  </Text>{" "}
                  shall have the meaning set forth in Section 7.1.
                </ListItem>

                <ListItem>
                  <ListIcon as={FaCircle} color="#000000" boxSize={2} />
                  <Text as="span" fontWeight="bold">
                    "Third Party Applications"
                  </Text>{" "}
                  means third party applications, websites, and services
                </ListItem>

                {/* Add all other definitions following the same pattern */}
              </List>
            </Box>

            {/* Section 2.0 */}
            <Box>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                2.0 LICENSE GRANTS
              </Heading>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  2.1 Service.
                </Text>
                Subject to the terms and conditions of this Agreement, NERD
                grants Customer a non-exclusive, non-transferable, worldwide
                license to access and use the Services to input and process
                Customer Data for Customer's own internal business purposes to
                provide digital verification of Credentials. Customer shall only
                allow Authorized Users to access the Service, and shall ensure
                that Authorized Users comply with the terms and conditions of
                this Agreement and any terms associated with the use of Third
                Party Applications. There are no implied licenses. All rights
                not expressly granted are reserved by NERD and its licensors.
              </Text>

              <Text>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  2.2 Restrictions.
                </Text>
                Customer shall not: (a) license, sublicense, sell, resell,
                transfer, assign, distribute or otherwise commercially exploit
                or make available to any third party (other than Authorized
                Users) the Services or the Content in any way; (b) modify or
                make derivative works based upon the Service or the Content; (c)
                create Internet "links" to the Service or "frame" or "mirror"
                any Content on any other server or wireless or Internet-based
                device; (d) attempt to access portions of the NCVS for which it
                has not ordered; or (e) reverse engineer or access the Service
                in order to: (i) build a competitive product or service; or (ii)
                copy any Content or any ideas, features, functions or graphics
                of the Service.
              </Text>

              <Text>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  2.3 Customer Data.
                </Text>
                Customer hereby grants to NERD a non-exclusive, worldwide
                license, to use, reproduce, create derivative works, display,
                store and perform Customer Data as reasonably necessary to
                provide the Services for access and use by Authorized Users.
              </Text>
            </Box>

            <Box mt={6}>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                3.0 OWNERSHIP
              </Heading>
              <Text>
                NERD and its suppliers shall own all right, title and interest
                in and to any Intellectual Property Rights in and to the NCVS
                Services, Documentation and derivative works thereof and related
                materials. Customer shall own all right, title and interest in
                and to Customer Data and all Intellectual Property Rights
                therein. All right, title and interest in Third Party
                Applications is the property of the respective owner.
              </Text>
            </Box>

            {/* Section 4.0 */}
            <Box mt={8}>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                4.0 OPERATION OF THE SERVICES
              </Heading>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  4.1 Implementation of Services.
                </Text>
                Promptly following the start date of the Service, NERD shall
                provide Customer with access to the Services. Customer will
                issue passwords to its Authorized Users and Customer
                acknowledges that Customer is fully responsible for all
                liabilities incurred by such use, and for any liabilities
                incurred through use of such passwords by anyone who obtains
                such passwords until Customer notifies NERD's customer service
                of such unauthorized use. NERD may temporarily disable access to
                the Service if Customer reports unauthorized use of the Service.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  4.2 Services Operation.
                </Text>
                NERD shall host, maintain and operate the NCVS for use by
                Customer and Authorized Users. NERD shall use commercially
                reasonable efforts to: (a) deploy industry standard security and
                encryption controls including without limitation, firewall and
                SSL technology; (b) monitor, track and report on NCVS
                availability; and (c) limit access to the Services only to
                Authorized Users.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  4.3 Compliance With Laws.
                </Text>
                Customer shall use the Services in compliance with all
                applicable laws, statutes, rules, regulations and terms of
                service. If necessary to comply with any of the foregoing, NERD
                may modify or suspend access to the Service. This remedy shall
                be in addition to, and shall not limit NERD's ability to
                terminate this Agreement based on material breach or pursue
                damages or other remedies available under law and equity.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  4.4 Upgrades.
                </Text>
                Customer understands that NERD may make upgrades to the NCVS or
                the manner in which they are made available, and that those
                upgrades may create differences in how the NCVS operate in the
                future.
              </Text>

              <Text>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  4.5 Protection of Customer Data.
                </Text>
                NERD will maintain administrative, physical, and technical
                safeguards for the protection of Customer Data as required under
                the Nigeria Data Protection Regulation. Those safeguards will
                include measures for preventing unauthorized access, use,
                modification or disclosure of Customer Data by NERD personnel
                except: (a) to provide the NCVS and prevent or address service
                or technical problems; (b) to comply with applicable law; or (c)
                as expressly permitted in writing by Customer.
              </Text>
            </Box>

            <Box mt={8}>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                5.0 FEES AND PAYMENT
              </Heading>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  5.1
                </Text>
                All payments of fees and charges are due net thirty (30) days
                from the date of invoice, subject to Customer's maintaining
                satisfactory credit arrangements with NERD. NERD reserves the
                right to modify Customer's credit terms at any time. Amounts not
                paid after 45 days (15 days overdue) are subject to a late
                payment charge of one and one-half percent (1.5%) per month, or
                if less, the highest rate permitted by law.
              </Text>

              <Text>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  5.2
                </Text>
                The prices for the Service are exclusive of all federal, state,
                or local sales, use or excise taxes, Customer shall pay all
                sales, use, excise and other taxes which may be levied upon
                either party in connection with this Agreement, excluding taxes
                based on NERD's net income.
              </Text>
            </Box>

            {/* Section 6.0 */}
            <Box mt={8}>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                6.0 CUSTOMER RESPONSIBILITIES
              </Heading>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  6.1
                </Text>
                Customer is solely responsible for the accuracy, quality,
                integrity, legality, reliability, appropriateness, and
                intellectual property ownership or right to use of all Customer
                Data, including the authenticity, validity, legitimacy, legality
                and content of Credentials. Customer shall ensure that Customer
                and Authorized Users comply with any terms of use associated
                with Third Party Applications. NERD shall have no responsibility
                or liability for Customer Data included in, or used in
                conjunction with the Services. For example, if Customer Data
                contains outdated or inaccurate information, NERD shall not be
                responsible or liable for such outdated or inaccurate
                information. Customer acknowledges that NERD is not affiliated
                with any issuer of Credentials and that Customer's selection and
                use of Credentials is at Customer's sole risk and expense.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  6.2
                </Text>
                Customer shall not: (a) send spam or otherwise duplicative or
                unsolicited messages; (b) send or store infringing, obscene,
                threatening, libelous, or otherwise unlawful or tortious
                material, including material harmful to children or in violation
                of third party privacy rights; (c) send or store material
                containing software viruses, worms, Trojan horses or other
                harmful computer code, files, scripts, agents or programs; (d)
                interfere with or disrupt the integrity or performance of the
                NCVS; or (e) attempt to gain unauthorized access to: (i) the
                NCVS or its related systems or networks; (ii) other user's
                accounts; or (iii) optional components of the NCVS that Customer
                has not paid for.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  6.3
                </Text>
                If Customer collects personal information from Authorized Users,
                Customer represents and warrants that it will comply with all
                applicable laws and will maintain and display a privacy policy
                that is consistent with the best practices of the industry.
              </Text>

              <Text>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  6.4
                </Text>
                Customer shall indemnify NERD and its suppliers against any and
                all claims, losses, costs and expenses, including reasonable
                attorneys' fees, which NERD and its suppliers may incur arising
                from Customer's failure to comply with Customer
                responsibilities.
              </Text>
            </Box>

            {/* Section 7.0 */}
            <Box mt={8}>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                7.0 TERM AND TERMINATION
              </Heading>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  7.1
                </Text>
                These Terms are effective unless and until terminated by either
                you or us. You may terminate these Terms at any time by
                notifying us that you no longer wish to use our Service.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  7.2
                </Text>
                If in our sole judgment you fail, or we suspect that you have
                failed, to comply with any term or provision of these Terms, we
                also may terminate this agreement at any time without notice and
                you will remain liable for all amounts due up to and including
                the date of termination and/or accordingly may deny you access
                to our Service (or any part thereof).
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  7.3
                </Text>
                NERD reserves the right to suspend or terminate your account and
                refuse any and all current or future use of the Service for any
                reason at any time. Such termination of will result in the
                deactivation or deletion of your account or your access to your
                account, and the forfeiture of all data in your account.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  7.4
                </Text>
                No refund will be provided by NERD for any remaining prepaid
                period for a prepaid access fee subscription.
              </Text>

              <Text>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  7.5
                </Text>
                All obligations and liabilities incurred by you before the
                termination date shall survive the termination of this agreement
                for all purposes.
              </Text>
            </Box>

            <Box mt={8}>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                8.0 INDEMNITY
              </Heading>
              <Text>
                NERD shall defend any claim, suit or proceeding brought against
                Customer so far as it is based on a claim that Customer's
                authorized use of the NCVS hereunder infringes any copyright,
                trade secret right or an existing patent (issued as of the
                Effective date). As a condition to such defense, Customer will
                provide NERD with prompt written notice of the claim and permit
                NERD to control the defense, settlement, adjustment or
                compromise of any such claim. Customer shall have no authority
                to settle any claim on behalf of NERD. The foregoing sets forth
                Customer's sole and exclusive remedy, for infringement or
                misappropriation by NERD of third party intellectual property
                rights.
              </Text>
            </Box>

            {/* Section 9.0 */}
            <Box mt={8}>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                9.0 WARRANTY DISCLAIMER
              </Heading>
              <Text fontStyle="italic" mb={2}>
                THE NCVS, DOCUMENTATION AND ANY SUPPORT SERVICES ARE PROVIDED
                "AS IS". NERD AND ITS SUPPLIERS DISCLAIM ALL WARRANTIES AND
                CONDITIONS WHATSOEVER, EXPRESS, IMPLIED OR STATUTORY, INCLUDING
                WITHOUT LIMITATION THE IMPLIED WARRANTIES OF TITLE,
                NON-INFRINGEMENT, MERCHANTABILITY, AND FITNESS FOR A PARTICULAR
                PURPOSE. NERD DOES NOT AND CANNOT CONTROL THE FLOW OF DATA TO OR
                FROM NERD'S NETWORK AND OTHER PORTIONS OF THE INTERNET.
                ACCORDINGLY, NERD DISCLAIMS ANY AND ALL LIABILITY ON ACCOUNT
                THEREOF.
              </Text>
              <Text>
                Customer acknowledges that it has not entered into this
                Agreement in reliance upon any warranty or representation except
                those specifically set forth herein.
              </Text>
            </Box>

            {/* Section 10.0 */}
            <Box mt={8}>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                10.0 LIMITATION OF LIABILITY
              </Heading>
              <Text fontStyle="italic">
                EXCEPT FOR BREACH OF SECTION 2.1, 2.2 OR 11, OR CUSTOMER'S
                FAILURE TO COMPLY WITH SECTION 6, IN NO EVENT SHALL: (A) EITHER
                PARTY BE LIABLE FOR ANY SPECIAL, INCIDENTAL OR CONSEQUENTIAL
                DAMAGES (INCLUDING BUT NOT LIMITED TO SUCH DAMAGES ARISING FROM
                BREACH OF CONTRACT OR WARRANTY OR FROM TORT (INCLUDING
                NEGLIGENCE) OR STRICT LIABILITY), OR FOR INTERRUPTED
                COMMUNICATIONS, LOST DATA OR LOST PROFITS, ARISING OUT OF OR IN
                CONNECTION WITH THIS AGREEMENT; AND (B) EITHER PARTY'S TOTAL
                LIABILITY FOR DAMAGES HEREUNDER EXCEED, IN THE AGGREGATE, THE
                AMOUNTS PAID TO NERD BY CUSTOMER TWELVE (12) MONTHS IMMEDIATELY
                PRIOR TO THE FIRST OCCURRENCE TO THE EVENTS GIVING RISE TO THE
                IMPOSITION OF LIABILITY HEREUNDER. CUSTOMER AND NERD AGREE THAT
                THE LIMITATIONS SPECIFIED IN THIS SECTION 10 SHALL APPLY
                NOTWITHSTANDING ANY FAILURE OF THE ESSENTIAL PURPOSE OF THIS
                AGREEMENT OR ANY LIMITED REMEDY HEREUNDER.
              </Text>
            </Box>

            {/* Section 11.0 */}
            <Box mt={8}>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                11.0 CONFIDENTIAL INFORMATION
              </Heading>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  11.1
                </Text>
                Any information that is transmitted by one party (the
                "Disclosing Party") to the other (the "Receiving Party")
                hereunder and: (a) if in written form, is marked "confidential"
                or with a similar legend by the Disclosing Party before being
                furnished to the other; or (b) if disclosed orally or visually
                is identified as such prior to disclosure and summarized, in
                writing, by the Disclosing Party to the Receiving Party within
                thirty (30) days, shall be deemed to be the confidential
                information of the Disclosing Party for purposes of this
                Agreement ("Confidential Information"). Each Receiving Party
                expressly undertakes to retain in confidence and not to disclose
                to any third party any such Confidential Information received
                from the Disclosing Party hereunder. Each Receiving Party
                further agrees to make no use of such Confidential Information
                except as necessary to exercise the rights or fulfill the
                obligations expressly granted under this Agreement. Each
                Receiving Party shall take reasonable steps to prevent
                unauthorized disclosure or use of the Disclosing Party's
                Confidential Information and to prevent such Confidential
                Information from falling into the public domain or into the
                possession of any unauthorized person. The Receiving Party shall
                not disclose Confidential Information of the Disclosing Party to
                any person or entity other than its officers, employees and
                legal or accounting advisors who need access to such
                Confidential Information in order to effect the intent of this
                Agreement and who have entered into written confidentiality
                agreements with such party which protects the Confidential
                Information of the Disclosing Party. The Receiving Party shall
                immediately give notice to the Disclosing Party of any
                unauthorized use or disclosure of Disclosing Party's
                Confidential Information. The Receiving Party agrees to assist
                the Disclosing Party in remedying such unauthorized use or
                disclosure of its Confidential Information.
              </Text>

              <Text>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  11.2
                </Text>
                Confidential Information shall not include information that: (a)
                was in the public domain at or subsequent to the time it was
                communicated to the Receiving Party by the Disclosing Party
                through no fault of the Receiving Party; (b) was rightfully in
                the Receiving Party's possession free of any obligation of
                confidence at or subsequent to the time such portion was
                communicated to the Receiving Party by the Disclosing Party; (c)
                was developed by employees or agents of the Receiving Party
                independently of and without reference to any information
                communicated to the Receiving Party by the Disclosing Party; or
                (d) was communicated by the Disclosing Party to an unaffiliated
                third party free of any obligation of confidence.
              </Text>
            </Box>

            {/* GENERAL PROVISIONS */}
            <Box mt={8}>
              <Heading
                as="h2"
                size={{ sm: "md", md: "md" }}
                color="#000000"
                mb={4}
              >
                12.0 GENERAL PROVISIONS
              </Heading>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  12.1
                </Text>
                This Agreement shall be governed by laws of the Federal Republic
                of Nigeria, without giving effect to any conflicts of laws
                provisions that would require the application of the laws of a
                different state. The parties hereby submit to the jurisdiction
                of, and waive any venue objections against the Federal Republic
                of Nigeria in any litigation arising out of this Agreement.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  12.2
                </Text>
                Except as expressly provided herein, all rights and remedies
                conferred under this Agreement or by any other instrument or law
                shall be cumulative and may be exercised singularly or
                concurrently. Failure by either party to enforce any contract
                term shall not be deemed a waiver of future enforcement of that
                or any other term.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  12.3
                </Text>
                Any notice or reports required or permitted to be given under
                this Agreement shall be given in writing and shall be delivered
                via email, in person, facsimile transmission or by certified or
                registered mail, postage prepaid, return receipt requested, and
                shall be deemed given upon personal delivery, three (3) days
                after deposit in the mail or upon acknowledgment of receipt of
                facsimile transmission. Notices shall be sent to the individuals
                executing this Agreement at the addresses first set forth above
                or such other address as either party may specify in writing.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  12.4
                </Text>
                Customer shall not assign, voluntarily, by operation of law, or
                otherwise, any rights, or delegate any duties, under this
                Agreement without NERD's prior written consent. NERD may without
                Customer's consent, assign all or any part of its rights and
                duties under this Agreement pursuant to a corporate
                reorganization, or to any entity with whom NERD merges, which
                NERD acquires or is acquired by, or to whom NERD sells all or
                substantially all of its assets to which this Agreement relates.
                Subject to the foregoing, this Agreement will bind and inure to
                the benefit of the parties and their respective successors and
                permitted assigns.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  12.5
                </Text>
                The parties are independent contractors and nothing contained in
                this Agreement shall be construed as creating any agency,
                partnership, or other form of joint enterprise between the
                parties.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  12.6
                </Text>
                Neither party shall be liable hereunder by reason of any failure
                or delay in the performance of its obligations hereunder (except
                for the payment of money) on account of: (a) any provision of
                any present or future law or regulation of the Federal Republic
                of Nigeria or any applicable law that applies to the subject
                matter hereof; and (b) strikes, shortages, riots, insurrection,
                fires, flood, storms, explosions, epidemics, acts of God, war,
                government action, acts of terrorism, earthquakes, power outages
                or any other cause which is beyond the reasonable control of
                such party.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  12.7
                </Text>
                If any provision of this Agreement shall be unenforceable or
                invalid under any applicable law or be so held by applicable
                court decision, such unenforceability or invalidity shall not
                render this Agreement unenforceable or invalid as a whole, and,
                in such event, such provisions shall be changed and interpreted
                so as to best accomplish the objectives of such unenforceable or
                invalid provision within the limits of applicable law or
                applicable court decisions.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  12.8
                </Text>
                This Agreement may be executed in two (2) or more counterparts,
                each of which shall be deemed an original, but all of which
                together shall constitute one and the same instrument.
                Facsimiles shall be treated as originals.
              </Text>

              <Text mb={4}>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  12.9
                </Text>
                The section headings and captions of this Agreement are included
                merely for convenience of reference. They are not to be
                considered part of, or to be used in interpreting this Agreement
                and in no way limit or affect any of the contents of this
                Agreement or its provisions.
              </Text>

              <Text>
                <Text fontWeight="bold" mb={2} as="span" mr="2">
                  12.10
                </Text>
                This Agreement, including all Exhibits and any other attachments
                to this Agreement, constitutes the entire agreement between the
                parties relating to this subject matter and supersedes all prior
                or simultaneous representations, discussions, negotiations, and
                agreements, whether written or oral. NERD may amend this
                Agreement at any time by posting the amended terms on its
                official website or any other URL as may be communicated from
                time to time. NERD's right to amend this Agreement includes the
                right to modify, add to, or remove terms. Customer's continued
                access or use of the Services constitutes acceptance of the
                amended terms. NERD reserves the right to ask Customer to
                acknowledge acceptance through an electronic click-through.
              </Text>
            </Box>

            <Divider my={6} />

            <Text textAlign="center" fontSize="sm">
              © {new Date().getFullYear()} National Education Repository and
              Databank (NERD). All rights reserved.
            </Text>
          </VStack>
        </Container>
      </Box>
    </>
  );
}

export default Index;
